import axios from 'axios';
import { config } from '../Configurator'
// import { multiplyFields, convertDateForApi, convertToDouble } from './../Utils'
import alertify from 'alertifyjs';

const endpoint = "CreateSource";

export const executeCreateSource = (att) => {
    
    let payload = {
        "pRequest": {
                    "SourceCode": "",
                    "SourceName": att.Source,
                    "SourceStatus": "Active",
                    "SourceStatusDesc": null,
                    "Contact": "",
                    "Salutation": "",
                    "WebSite": null,
                    "Telephone": null,
                    "Mobile": null,
                    "Email": "",
                    "Fax": null,
                    "Notes": null,
                    "SourceCategory": att.SourceCategory,
                    "SourceCategoryDesc": "",
                    "EnableCommission": true,
                    "SourceArea": "",
                    "SourceAreaDesc": null,
                    "SourceRegion": att.SourceRegion,
                    "SourceRegionDesc": null,
                    "SourceReference": null,
                    "SourceRep": "",
                    "SourceLead": "",
                    "SourceStatementText": "",
                    "SourceCreatedDate": "",
                    "Additional1UserName": "",
                    "Additional2UserName": "",
                    "SourceBrokerNetworks": [
                        {
                            "BrokerNetworkCompanyName": ""
                        },
                        {
                            "BrokerNetworkCompanyName": ""
                        }
                    ],
                    "DistanceFromCurrent": 0,
                    "SourceAddress": {
                        "HouseName": "",
                        "HouseNumber": "",
                        "Address1": "",
                        "Address2": "",
                        "Address3": "",
                        "Address4": "",
                        "PostCode": ""
                    },
                    "SourceCaseDetail": {
                        "TotalCases": 0,
                        "TotalCompletedCases": 0,
                        "TotalCancelledCases": 0,
                        "TotalInProgressCases": 0,
                        "TotalLoan": 0
                    },
                    "SourceTypes": [
                        {
                            "SourceType": att.SourceType
                        }
                    ],
                    "SourceAffiliates" : [
                        {
                        "sourceAffiliateCode": "",
                        "sourceAffiliateName": att.SourceAffiliate,
                        "contact": att.SourceAffiliate,
                        "webSite": null,
                        "telephone": "",
                        "fax": null,
                        "mobile": null,
                        "email": att.AffiliateEmail,
                        "salutation": null,
                        "sourceAffiliateStatus": "3 - Active",
                        "sourceAffiliateStatusDesc": "Currently Active",
                        "sourceAffiliateArea": null,
                        "sourceAffiliateAreaDesc": null,
                        "sourceAffiliateRegion": null,
                        "sourceAffiliateRegionDesc": null
    }
]
                },
        "UserInfo": {
            "Username": localStorage.getItem('bo_email'),
            "Password": localStorage.getItem('bo_password')
        }
    }

    axios.post(config().base_url + endpoint, payload).then(function(response){
        if(response.data.d.EnquiryResult.SuccessCode==0) {
            window.location.href = "/sources/";
        } else {
            alertify.confirm('Error', response.data.d.EnquiryResult.Message, null, null);
        }
    }).catch(function (error){
        alertify.confirm('Error', error.message, null, null);
    });

}

export default {
    executeCreateSource
};
